/* global globalThis */
import { requestDisplayJson } from "./displayRequest.mjs";
// Same-origin metadata only. A random page instance is not an authenticated identity.
const pageInstance = globalThis.crypto?.randomUUID?.()
  || `page-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,12)}`;
export function scopedClientVersion(doc = globalThis.document) {
  const scripts = doc?.querySelectorAll?.('script[src]') || [];
  for (const script of scripts) {
    const match = String(script.getAttribute('src')).match(/\/static\/js\/(main\.[a-zA-Z0-9._-]+\.js)(?:[?#]|$)/);
    if (match) return match[1];
  }
  return 'development';
}
export function validateScopedPayload(payload) {
  if (!payload || payload.ok !== true
      || !['leads','clients','prospects','liftSales'].every(key => Array.isArray(payload[key]))) {
    throw Object.assign(new Error('Resposta incompleta ao carregar os dados do CRM'),{ code:'invalid_payload' });
  }
  return payload;
}
export async function fetchScopedData({ storeIds,signal,fetchImpl = globalThis.fetch,document:doc = globalThis.document,timeoutMs = 20000 }) {
  const requestId = globalThis.crypto?.randomUUID?.()
    || `request-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,12)}`;
  const {response,payload} = await requestDisplayJson(`/api/crm/scoped-data?storeIds=${encodeURIComponent(storeIds.join(','))}&cardsOnly=1`, {
    credentials:'same-origin',cache:'no-store',signal,
    headers:{ Accept:'application/json','X-CRM-Client-Version':scopedClientVersion(doc),
      'X-CRM-Client-Instance':pageInstance,'X-CRM-Request-Id':requestId },
  },{fetchImpl,timeoutMs});
  if (!response.ok) {
    const details = payload || {};
    throw Object.assign(new Error(`HTTP ${response.status}`),{
      status:response.status,
      code:/^[a-z_]{1,60}$/.test(details.code || '') ? details.code : 'http_error',
      diagnosticId:response.headers?.get('X-CRM-Request-Id') || requestId,
    });
  }
  return validateScopedPayload(payload);
}
